let DOM_DECODER;
function decodeHtmlEntities(str) {
  if (DOM_DECODER === void 0) {
    DOM_DECODER = document.createElement("textarea");
  }
  DOM_DECODER.innerHTML = str;
  return DOM_DECODER.value;
}

export { decodeHtmlEntities };
//# sourceMappingURL=dom.decode-xml-entities.js.map
